import { jsx, jsxs } from 'react/jsx-runtime';
import logger from '@agoras/logger';
import { mergeStyleSets, NeutralColors, Panel, Stack, Text, PrimaryButton, Link, Icon } from '@fluentui/react';
import { AppContext } from '../../../../context/context.esm.js';
import { useTranslation } from 'react-i18next';
import { useContext, useCallback } from 'react';
import { headerContext } from '../../../context.esm.js';
import { BLOG_LOCATION_LINK, PURCHASE_IN_APPSOURCE_LINK, ISV_LINK, CONTACT_US_LINK } from './constants.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var classNames = mergeStyleSets({
    root: {
        height: 'inherit'
    },
    subTitle: {
        fontWeight: 600
    },
    primaryButton: {
        // TODO: AppSource overrides the color for 'a' tag with 'inherit', the optimal solution is to remove the '!important' and fix it with another way
        color: "".concat(NeutralColors.white, " !important")
    }
});
var HelpPanel = function(param) {
    var isOpen = param.isOpen, dismissPanel = param.dismissPanel;
    var _useContext = useContext(AppContext), _useContext_locale = _useContext.locale, locale = _useContext_locale === void 0 ? "en-us" : _useContext_locale, unifiedExperience = _useContext.unifiedExperience;
    var storefront = unifiedExperience ? 'Marketplace' : 'AppSource';
    var t = useTranslation('header').t;
    var links = [
        {
            href: "".concat(PURCHASE_IN_APPSOURCE_LINK.replace('{0}', locale)),
            name: t('Purchase in Storefront', {
                storefront: storefront
            })
        },
        {
            href: "".concat(ISV_LINK.replace('{0}', locale)),
            name: t('Sell in Storefront', {
                storefront: storefront
            })
        },
        {
            href: BLOG_LOCATION_LINK,
            name: t('Blog')
        }
    ];
    var handleDismiss = useCallback(function() {
        logger.info('', _object_spread({
            action: 'Support',
            actionModifier: 'Close panel'
        }, headerContext));
        dismissPanel();
    }, [
        dismissPanel
    ]);
    var handleLogLink = useCallback(function(param) {
        var type = param.name, url = param.url;
        logger.info(JSON.stringify({
            type: type,
            url: url
        }), _object_spread({
            action: 'Support',
            actionModifier: 'Click link'
        }, headerContext));
    }, []);
    return /*#__PURE__*/ jsx(Panel, {
        headerText: t('Help & Support') || '',
        isOpen: isOpen,
        onDismiss: handleDismiss,
        closeButtonAriaLabel: "Close",
        isLightDismiss: true,
        children: /*#__PURE__*/ jsxs(Stack, {
            tokens: {
                childrenGap: 24
            },
            children: [
                /*#__PURE__*/ jsxs(Stack, {
                    tokens: {
                        childrenGap: 16
                    },
                    horizontalAlign: "start",
                    children: [
                        /*#__PURE__*/ jsx(Text, {
                            children: t("Need assistance with Microsoft Storefront? We'll get you the help you need. Contact Microsoft support to get help and support.", {
                                storefront: storefront
                            })
                        }),
                        /*#__PURE__*/ jsx(PrimaryButton, {
                            text: t('Contact us') || '',
                            allowDisabledFocus: true,
                            href: CONTACT_US_LINK,
                            target: "_blank",
                            rel: "noreferrer",
                            className: classNames.primaryButton,
                            onClick: function() {
                                handleLogLink({
                                    name: 'Contact us',
                                    url: CONTACT_US_LINK
                                });
                                handleDismiss();
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ jsxs(Stack, {
                    tokens: {
                        childrenGap: 16
                    },
                    children: [
                        /*#__PURE__*/ jsx(Text, {
                            variant: "mediumPlus",
                            className: classNames.subTitle,
                            children: t('Learn more about Storefront', {
                                storefront: storefront
                            })
                        }),
                        links.map(function(link) {
                            var name = link.name, href = link.href;
                            return /*#__PURE__*/ jsx(Link, {
                                href: href,
                                onClick: function() {
                                    handleLogLink(link);
                                    handleDismiss();
                                },
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ jsxs(Stack, {
                                    horizontal: true,
                                    tokens: {
                                        childrenGap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ jsx(Stack.Item, {
                                            children: name
                                        }),
                                        /*#__PURE__*/ jsx(Stack.Item, {
                                            children: /*#__PURE__*/ jsx(Icon, {
                                                iconName: "NavigateExternalInline"
                                            })
                                        })
                                    ]
                                })
                            }, name);
                        })
                    ]
                })
            ]
        })
    });
};

export { HelpPanel as default };
